import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";

import OfficerFormModalAction from "@common/redux/actions/OfficerFormModalAction";
import EnforcementAction from "@common/redux/actions/EnforcementAction";
import OfficerAction from "@common/redux/actions/OfficerAction";
import useLogin from "@common/components/hooks/useLogin";
import IncidentClient from "@common/api/IncidentClient";
import enforcementCreatePayload from "@common/components/helpers/Enforcement/enforcementSubmission";
import { filterEnforcementTypes } from "@common/components/helpers/options/enforcementTypeOptions";
import { parseEnforcementVisitResponse } from "@common/components/helpers/compliance";
import fetchEnforcementTypes from "@common/components/helpers/Enforcement/fetchEnforcementTypes";
import useCompliance from "./useCompliance";

// Also known as "Visitor Log"
const useEnforcementForm = () => {
  const methods = useFormContext();
  const {
    reset,
    watch,
    formState: { isValid, errors },
  } = methods;
  const [officerTypeId, isGamblingRelated] = watch([
    "officerTypeId",
    "isGamblingRelated",
  ]);

  const { officer } = useSelector((store) => OfficerAction.getStatePath(store));
  const { typeOptions, loadingTypes } = useSelector((store) =>
    EnforcementAction.getStatePath(store),
  );

  const [{ siteGuid }] = useLogin();
  const { resetComplianceForms, submitComplianceForm } = useCompliance();

  useEffect(() => {
    OfficerFormModalAction.dispatch({
      officerType: officerTypeId,
      isEnforcementPolice: officerTypeId === 1 ? true : false,
    });
  }, [officerTypeId]);

  const options = filterEnforcementTypes(isGamblingRelated, typeOptions);

  const resetForm = (redirect) => {
    resetComplianceForms(redirect);
    fetchEnforcementTypes();
  };

  const onSubmit = (values) => {
    if (!isValid) {
      console.error(errors);
    }

    const payload = enforcementCreatePayload(values, officer, siteGuid);

    submitComplianceForm({
      client: IncidentClient,
      payload,
      resetForm,
      desktopCallback: (response) =>
        reset(parseEnforcementVisitResponse(response)),
    });
  };

  const handleNewOfficer = (value) => {
    value.officerType = { id: officerTypeId };
    methods.setValue("officer", value, { shouldValidate: true });

    OfficerAction.editOfficer(value);
  };

  const handleRemoveOfficer = () => {
    OfficerAction.editOfficer(null);
  };

  return {
    officerTypeId,
    loadingTypes,
    isGamblingRelated,
    options,
    onSubmit,
    handleNewOfficer,
    handleRemoveOfficer,
    resetForm,
    methods,
  };
};

export default useEnforcementForm;
